
export enum Endpoint {
    BASE_URL = "https://08egthody3.execute-api.eu-north-1.amazonaws.com/Prod",
    PODCASTS = "/podcasts",
    QUERY = "/query",
    FILTERS = "/filters"

}

